/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_DiscardInputs */

const en_us2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const pt_br2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const es_419_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const pt_pt2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const fr_fr2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner`)
};

const de_de2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

const it_it2_draft_discard = /** @type {(inputs: Draft_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Draft_DiscardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_discard = /** @type {((inputs?: Draft_DiscardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_DiscardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_discard(inputs)
	if (locale === "es-419") return es_419_draft_discard(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_discard(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_discard(inputs)
	if (locale === "de-DE") return de_de2_draft_discard(inputs)
	if (locale === "it-IT") return it_it2_draft_discard(inputs)
	return en_us2_draft_discard(inputs)
});
export { draft_discard as "draft.discard" }